import React from "react";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import { useStyles } from "./styles";

const KANBAN_BY_PROFILE = {
  1: [{ name: "Solicitud recibida", color: "#1976d2" }, { name: "Pendiente de confirmación", color: "#ed6c02" }, { name: "Cita confirmada", color: "#2e7d32" }, { name: "Cita completada", color: "#66bb6a" }, { name: "Reprogramar / Cancelada", color: "#d32f2f" }],
  2: [{ name: "Lead Recibido", color: "#1976d2" }, { name: "Demo Agendada", color: "#ed6c02" }, { name: "Demo Realizada", color: "#0288d1" }, { name: "Propuesta Enviada", color: "#7b1fa2" }, { name: "Negociación", color: "#ed6c02" }, { name: "Cerrado/Ganado", color: "#2e7d32" }, { name: "Perdido", color: "#d32f2f" }],
  3: [{ name: "Solicitud", color: "#1976d2" }, { name: "Cita Confirmada", color: "#2e7d32" }, { name: "En Consulta", color: "#ed6c02" }, { name: "Consulta Completada", color: "#66bb6a" }, { name: "Seguimiento Activo", color: "#0288d1" }, { name: "Cancelada", color: "#d32f2f" }],
  4: [{ name: "Interesado", color: "#1976d2" }, { name: "Sesión de Prueba", color: "#ed6c02" }, { name: "Sesión Confirmada", color: "#2e7d32" }, { name: "En Curso", color: "#0288d1" }, { name: "Sesión Completada", color: "#66bb6a" }, { name: "Abandonó/Pausó", color: "#d32f2f" }],
  5: [{ name: "Solicitud", color: "#1976d2" }, { name: "Diagnóstico", color: "#ed6c02" }, { name: "Visita Confirmada", color: "#2e7d32" }, { name: "En Ejecución", color: "#0288d1" }, { name: "Visita Completada", color: "#66bb6a" }, { name: "En Garantía", color: "#7b1fa2" }, { name: "Cancelada", color: "#d32f2f" }]
};

export default function Step6KanbanPreview({ profileId }) {
  const c = useStyles();
  const columns = KANBAN_BY_PROFILE[profileId] || KANBAN_BY_PROFILE[1];
  return (
    <>
      <Typography variant="h6" gutterBottom>Vista previa columnas Kanban</Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>Se crearán estas columnas en el tablero según tu perfil.</Typography>
      <div className={c.kanbanPreview}>
        {columns.map((col, i) => (
          <Chip key={i} label={col.name} size="small" style={{ backgroundColor: col.color, color: "#fff", margin: 4 }} />
        ))}
      </div>
    </>
  );
}
